// core
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// campfire
import { OpenModule } from '@campfire-nx/open';
import { RaptorModule } from '@campfire-nx/raptor';
import { MaterialModule } from '@campfire-nx/material';

// components
import { ComponentsModule } from '@open-portal-app/components/components.module';

// layout components
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { EmptyLayoutComponent } from './empty-layout/empty-layout.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { BasicLayoutComponent } from './basic-layout/basic-layout.component';

// routing
import { LayoutRoutingModule } from './layout-routing.module';
import { PageUnauthorisedComponent } from './page-unauthorised/page-unauthorised.component';
import { PageBadRequestComponent } from './page-bad-request/page-bad-request.component';
import { MagicLinkExpiredComponent } from './magic-link-expired/magic-link-expired.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';


@NgModule({
  declarations: [
    MainLayoutComponent,
    EmptyLayoutComponent,
    PageNotFoundComponent,
    HeaderComponent,
    FooterComponent,
    PageUnauthorisedComponent,
    PageBadRequestComponent,
    MagicLinkExpiredComponent,
    LoginComponent,
    LogoutComponent,
    BasicLayoutComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([]),
    LayoutRoutingModule,
    ComponentsModule,
    RaptorModule,
    OpenModule,
    MaterialModule
  ],
  exports: [
    MainLayoutComponent,
    EmptyLayoutComponent,
    BasicLayoutComponent
  ]
})
export class LayoutModule { }
